import { configureStore } from "@reduxjs/toolkit"
import cartReducer from "../features/cartSlice"
import offerReducer from "../features/offerSlice"

const store = configureStore({
    reducer: {
        cart: cartReducer,
        offer: offerReducer,
    }
})

export default store